import { useOutletContext } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { useSearchParams } from 'react-router-dom'

import { GoogleMapsProvider } from 'modules/core/components/GoogleMaps/GoogleMapsProvider'
import Loading from 'modules/core/components/Loading'

import CreateMileageForm from 'modules/expenses/components/expenses/Detail/_newForm/CreateMileageForm'
import { fieldEnabled } from 'modules/expenses/hooks/useExpensesCustomization'
import { useExpensesNavigation } from 'modules/expenses/hooks/useExpensesNavigation'
import useNewExpensesPage from 'modules/expenses/hooks/useNewExpensesPage'
import type { RouteContextParams } from 'modules/expenses/lib/my_expenses/RouteContextParams'
import { useMyExpenses } from 'modules/expenses/pages/my_expenses/MyExpensesContext'

const NewMileagePage = () => {
  const { group } = useOutletContext<RouteContextParams>()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { navigation } = useExpensesNavigation()
  const { featureAvailabilities } = useMyExpenses()

  const {
    customizationFields,
    hasProjectsFeature,
    hasReportOnBehalfFeature,
    loading,
    canCreateExpensesForOthers,
    canSeeEmployeeLegalEntity,
  } = useNewExpensesPage()

  if (loading) return <Loading inline />

  return (
    <GoogleMapsProvider
      mapsEnabled={
        fieldEnabled(customizationFields, 'mileage', 'from') ||
        fieldEnabled(customizationFields, 'mileage', 'to')
      }
    >
      <CreateMileageForm
        onClose={() =>
          navigate({
            pathname: navigation.helpers.getExpensesFormBackPath(),
            search: searchParams.toString(),
          })
        }
        customizationFields={customizationFields}
        hasProjectsFeature={hasProjectsFeature}
        hasReportOnBehalfFeature={hasReportOnBehalfFeature}
        canCreateExpensesForOthers={canCreateExpensesForOthers}
        canSeeEmployeeLegalEntity={canSeeEmployeeLegalEntity}
        groupCurrency={group?.currency}
        hasMileageMultipleStops={featureAvailabilities.mileageMultipleStopsEnabled}
      />
    </GoogleMapsProvider>
  )
}

export default NewMileagePage
